// Site Visitor

<template>
  <section class="lms3030-container">
    <div class="lms3030 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li><span aria-current="page">Site Visitors</span></li>
      </Ul>
      <!-- <sym-card class="lams" headerClass="p-1 pl-2">
        <div slot="header" class="reg-stat justify-between align-items-center">
          <p class="reg-stat-title serif bold">Regional Stats</p>
          <sym-combo
            v-model="regionId"
            :input-width="62"
            display-field="regionFullName"
            :datasource="regions"
            @changed="onRegionIdChanged"
          ></sym-combo>
        </div>
      </sym-card> -->

      <!-- <sym-tabs id="tabs" v-model="activeTabIndex" @changed="onActiveTabIndexChanged">
        <sym-tab title=" IVAS" icon="cube">
          <div class="table-scroll-wrapper"> -->
      <!-- <sym-card class="lams-light mb-2 border-main" bodyClass="p-2">
        <p class="reg-summary-title serif bold text-charcoal">Summary ● All Regions</p>
      </sym-card> -->

      <!-- <div class="chart-container mb-3">
              <div class="w-100 pos-relative border-main">
                <canvas id="all-regions-chart" class="p-2"></canvas>
              </div> -->

      <div class="w-100 pos-relative border-main">
        <canvas id="visits-chart" class="p-2"></canvas>
      </div>
    </div>
    <!-- </div> -->
    <!-- </sym-tab> -->

    <!-- <sym-tab title=" PLA" icon="copy">
          <div class="table-scroll-wrapper">
            <sym-card class="lams-light mb-2 border-main" bodyClass="p-2">
              <p class="reg-summary-title serif bold text-charcoal">Summary ● All PLA</p>
            </sym-card>

            <div class="chart-container mb-3">
              <div class="w-100 pos-relative border-main">
                <canvas id="all-regions-chart" class="p-2"></canvas>
              </div>

              <div class="w-100 pos-relative border-main">
                <canvas id="visits-chart" class="p-2"></canvas>
              </div>
            </div>
          </div>
        </sym-tab>
      </sym-tabs> -->

    <!-- <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div> -->
  </section>
</template>

<script>
import { get } from "../../js/http";

import * as lams from "../../js/lams";

import { drawLineChart } from "../../js/graph"; //drawBarChart

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3030",

  data() {
    return {
      // regionId: 0,
      // regions: [],
      charts: [],

      // summaryDateRange: "",
      // offices: [],
      // submittedCounts: [],
      // approvedCounts: [],
      // pendingCounts: [],
      // rejectedCounts: [],
      // cancelledCounts: [],
      // activeTabIndex: 0,
      visitDates: [],
      visitCounts: [],
    };
  },

  methods: {
    loadData() {
      const me = this,
        wait = me.wait();

      me.getStats().then(
        (data) => {
          me.stopWait(wait);

          // regional summary
          // me.offices = data.stats.map((o) => o.boardCode);
          // me.submittedCounts = data.stats.map((o) => o.submittedCount);
          // me.approvedCounts = data.stats.map((o) => o.approvedCount);
          // me.rejectedCounts = data.stats.map((o) => o.rejectedCount);
          // me.pendingCounts = data.stats.map((o) => o.pendingCount);
          // me.cancelledCounts = data.stats.map((o) => o.cancelledCount);
          // // site visits
          me.visitDates = data.visits.map((o) => {
            return me.core.toDateFormat(o.visitDate, true, "dd MMM");
          });

          me.visitCounts = data.visits.map((o) => o.visitCount);

          me.drawCharts();
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },
    // getTargetPath() {
    //   return {
    //     name: this.$options.name,
    //     query: {
    //       activeTab: this.activeTabIndex,
    //     },
    //   };
    // },
    // syncValues(p, q) {
    //   const me = this;

    //   if ("activeTab" in q) {
    //     let index = parseInt(q.activeTab);
    //     if (!isNaN(index)) {
    //       me.activeTabIndex = index;
    //     }
    //   }
    // },

    // API calls

    getStats() {
      const me = this,
        wait = me.wait();

      let data = {};

      // return me
      //   .getRegionaalStats()
      //   .then((stats) => {
      //     data.stats = stats;
      return (
        me
          .getVisitStats()
          // })
          .then((visits) => {
            me.stopWait(wait);
            data.visits = visits;
            return data;
          })
          .catch((fault) => {
            me.stopWait(wait);
            me.showFault(fault);
          })
      );
    },

    getRegionaalStats() {
      return get("api/stats/regions");
    },

    getVisitStats() {
      return get("api/stats/visit");
    },

    // event handlers

    onRegionIdChanged(regionId) {
      let route = {
        name: "lms3010",
        query: {
          regionId: regionId,
        },
      };
      this.go(route);
    },
    // onActiveTabIndexChanged() {
    //   this.reload();
    // },

    // helpers

    drawSummaryChart() {
      // const me = this;
      // const mq = window.matchMedia("(max-width: 600px)");
      // let aspectRatio = 1.4;
      // if (mq.matches) {
      //   aspectRatio = 1;
      // }
      //   let chartData = {
      //     labels: me.offices,
      //     datasets: [
      //       {
      //         label: "Submitted",
      //         data: me.submittedCounts,
      //         backgroundColor: "#3cba9f",
      //       },
      //       {
      //         label: "Approved",
      //         data: me.approvedCounts,
      //         backgroundColor: "#507cc4",
      //       },
      //       {
      //         label: "Pending",
      //         data: me.pendingCounts,
      //         backgroundColor: "#c49d50",
      //       },
      //       // {
      //       //   label: 'Rejected',
      //       //   data: me.rejectedCounts,
      //       //   backgroundColor: '#c45850'
      //       // },
      //       {
      //         label: "Cancelled",
      //         data: me.cancelledCounts,
      //         backgroundColor: "#c45850",
      //       },
      //     ],
      //   };
      //   let options = {
      //     scales: {
      //       x: {
      //         ticks: {
      //           font: {
      //             size: 14,
      //             weight: 700,
      //           },
      //         },
      //       },
      //       y: {
      //         beginAtZero: true,
      //       },
      //     },
      //     plugins: {
      //       title: {
      //         display: true,
      //         text: "Regional Statistics",
      //         font: {
      //           size: 20,
      //           lineHeight: 1,
      //         },
      //       },
      //       subtitle: {
      //         display: true,
      //         text: me.summaryDateRange,
      //         font: {
      //           size: 16,
      //         },
      //         padding: {
      //           bottom: 0,
      //         },
      //       },
      //       legend: {
      //         labels: {
      //           boxWidth: 20,
      //         },
      //       },
      //     },
      //   // aspectRatio: 1.4
      //   aspectRatio: aspectRatio,
      // };
      //   let chart = drawBarChart("all-regions-chart", chartData, options);
      //   this.charts.push(chart);
    },

    drawVisitChart() {
      const me = this;

      let chartData = {
        labels: me.visitDates,
        datasets: [
          {
            label: "Total",
            data: me.visitCounts,
            backgroundColor: "rgb(195, 230, 203, 0.4)",

            borderColor: "#28a745",
            borderWidth: 2,
            // pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",

            fill: true,
            tension: 0.6,
          },
        ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
        },

        plugins: {
          legend: {
            display: false,
          },

          title: {
            display: true,
            text: "Site Visitors",
            font: {
              size: 20,
              lineHeight: 1,
            },
            padding: {
              top: 10,
              bottom: 70,
            },
          },
        },

        aspectRatio: 1.8,
      };

      let chart = drawLineChart("visits-chart", chartData, options);
      this.charts.push(chart);
    },

    drawCharts() {
      const me = this;

      me.charts.forEach((chart) => {
        chart.destroy();
        chart = null;
      });

      me.drawVisitChart();

      // setTimeout(() => {
      //   me.drawSummaryChart();
      // }, 600);
    },
  },

  mounted() {
    const me = this;

    me.dom.on(window, "resize", me.drawCharts);

    me.regions = lams.getRegionList().slice(0);
    me.regions.unshift({
      regionId: 0,
      regionFullName: "--- Select Region ---",
    });

    me.summaryDateRange = lams.getCurrentYearCoverage();
    me.loadData();
  },

  beforeDestroy() {
    this.dom.off(window, "resize", this.drawCharts);
  },
};
</script>

<style scoped>
.lms3030-container {
  display: flex;

  justify-content: center;
  align-items: center;
}

.lms3030 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.reg-stat-title,
.reg-summary-title {
  font-size: 1.125rem;
  margin-bottom: 0;
  padding-left: 0.125rem;
}

.reg-stat {
  display: flex;
}

.reg-stat >>> .form-control {
  margin-bottom: 0;
}

.chart-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  grid-auto-flow: dense;
}

@media (max-width: 1024px) {
  .lms3030 {
    width: 90%;
    padding: 2rem;
  }
}

@media (max-width: 800px) {
  .chart-container {
    display: block;
  }
}

@media (max-width: 640px) {
  .lms3030-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms3030 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }

  .reg-stat {
    display: block;
  }

  .reg-stat-title,
  .reg-summary-title {
    font-size: 1rem;
  }

  .reg-stat-title {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
}

@media (max-width: 420px) {
  .lms3030 {
    padding: 0.5rem;
  }
}
</style>
